import React from 'react'
import { Button } from '@material-ui/core'
import { Close } from '@material-ui/icons';
import Shakey from './Shakey'

export default function QuizStatusBar({ canContinue, quiz, shake, onContinue }) {
  return (
    <div>
      <Shakey shake={shake}>
        <Button
          style={{ width: '100%' }}
          color="primary"
          variant="contained"
          disabled={!canContinue}
          onClick={onContinue}
        >
          Check
        </Button>
      </Shakey>
    </div>
  )
}